import React, { useEffect, useRef } from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import * as Const from "../_Const";
import Button from "./Button";
import useScreenType from "../hooks/useScreenType";
const Dialog = ({
  title,
  subtitle,
  message,
  buttonText = "Zavřít",
  type = "info",
  showCloseButton = true,
  onClick,
  useAutoClose = true,
  closeAfter = 10000,
  openStateChange,
}) => {
  const screenType = useScreenType();
  const timerIdRef = useRef(null);

  useEffect(() => {
    function runAfterLoad() {
      if (useAutoClose) {
        timerIdRef.current = setTimeout(() => {
          if (openStateChange) {
            openStateChange(false);
          }
          onClick();
          console.log(`Dialog Close called after interval ${closeAfter}`);
        }, closeAfter);
      }
    }

    runAfterLoad();

    return () => {
      if (timerIdRef.current) {
        clearTimeout(timerIdRef.current);
        console.log("clearing dialog timeout");
      }
    };
  }, []);

  function handleOnClick() {
    if (openStateChange) {
      openStateChange(false);
    }
    onClick();
  }

  const textColor = type === "error" ? "text-error-dark" : "text-primary";

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "parent-div":
          css = "h-[340px] mt-4";
          break;
        case "title":
          css = "text-4xl";
          break;
        case "text":
          css = "text-3xl";
          break;
        case "btn":
          css = "bottom-4 h-[72px] min-w-52 text-xl";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "parent-div":
          css = "h-[550px] mt-8";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "text":
          css = "text-5xl";
          break;
        case "btn":
          css = "bottom-4 h-20 min-w-72 text-3xl";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "parent-div":
          css = "h-[580px] mt-8";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "text":
          css = "text-5xl";
          break;
        case "btn":
          css = "bottom-4 h-20 min-w-72 text-3xl";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "parent-div":
          css = "h-[550px] mt-8";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "text":
          css = "text-5xl";
          break;
        case "btn":
          css = "bottom-4 h-20 min-w-72 text-3xl";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  function replaceWithBr(text) {
    return text?.replace(/\n/g, "<br />") ?? text;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }
  return (
    <div className={`${getCssFor("parent-div")} flex flex-col place-content-center items-center`}>
      <h1 className={`${getCssFor("title")} text-accent text-center`}>{title}</h1>
      <div className="grow mx-16 text-center flex justify-center items-center">
        <div className={`${getCssFor("text")} text-center ${textColor}`}>
          <span dangerouslySetInnerHTML={{ __html: replaceWithBr(message) }} />
        </div>
      </div>
      {showCloseButton && (
        <Button type="terminal-dark" title={buttonText} className={`${getCssFor("btn")} absolute  rounded-none`} showIcon={false} onClick={handleOnClick} />
      )}
    </div>
  );
};

export default Dialog;
